import React from 'react';
import styled from 'styled-components';
import UserRequest from './UserRequest';
import { flexGap } from 'untils/polyfill/flex';

const VideoBackground = styled.video`
  width: 100%;
  height: 100%;
  bottom: 0;
  position: absolute;
  object-fit: cover;
`;

const InfoContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: var(--home-section-width);
  ${flexGap('12px')}
`;

const TextContainer = styled.div`
  display: flex;
  ${flexGap('24px')}
  align-items: center;
  line-height: normal;
`;

const Title = styled.h1`
  font-size: 64px;
  color: #ffffff;
  font-weight: 600;
  margin: 0;
`;

const Desc = styled.p`
  font-size: 20px;
  color: #ffffff;
  font-weight: 600;
`;

const Img = styled.img`
  width: 160px;
  height: 51px;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(12, 28, 53, 0.91) 0%, rgba(20, 36, 61, 0) 47.4%),
    linear-gradient(180deg, rgba(9, 19, 44, 0.64) 13.72%, rgba(64, 83, 134, 0.16) 73.57%);
`;

const Banner = () => {
  return (
    <>
      <VideoBackground autoPlay loop muted>
        <source src={`${process.env.REACT_APP_ASSET_URL}/vedio/home-banner.mp4`} type="video/mp4" />
      </VideoBackground>
      <Overlay></Overlay>
      <InfoContainer>
        <InfoContent>
          <TextContainer>
            <Title>fly airacer</Title>
            <Img src="/imgs/svg/home/aircraft.svg" alt="aircraft" />
          </TextContainer>
          <Desc>book a private jet charter today</Desc>
          <UserRequest />
        </InfoContent>
      </InfoContainer>
    </>
  );
};

export default Banner;
